import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import * as _ from "lodash";
import { getTenantId } from "../helper";
import { plainToClass } from "class-transformer";
import { AssetTypeModel, IAssetTypeDTO } from "../models/asset/assetType";
import { AssetTypePropertyModel, IAssetTypePropertyDTO } from "../models/asset/assetTypeProperty";
import { IAssetTypeMaster } from "../models/asset/assetTypeMaster";
import { GuidItemModel } from "../models/shared/guidItem";
import { AssetManagerModel } from "../models/asset/assetManagerListingDTO";
import { IAssetManagerResponse } from "../models/asset/response/assetManagerResponse";
import { IAssetManagerDetailView } from "../models/asset/assetManagerDetailViewDTO";
import { AssetDetailViewModel } from "../models/asset/assetDetailViewDTO";
import { AssetPropertiesDetailViewModel } from "../models/asset/assetPropertiesDetailViewDTO";
//import { IAssetSearchDataListingDTO } from "../models/asset/assetSearchListingDTO";
import { Guid } from "guid-typescript";
import { AssetPropertyModel } from "../models/asset/assetProperty";
import { AssetModel } from "../models/asset/asset";
import { AssetControlTypeModel } from "../models/asset/assetControlType";
import { AssetEditModel, IAssetEditDTO } from "../models/asset/assetEdit";
import { AssetLookupSearchModel } from "../models/asset/assetLookupSearchDTO";
import { EmployeesGridViewModel } from "../models/asset/employeesGridViewDTO";
import { IAssetAssignment } from "../models/asset/assetAssignment";
import { EmployeeAssetsGridViewModel } from "../models/asset/employeeAssetsGridViewDTO";
import { AssetAssignmentEditModel } from "../models/asset/assetAssignmentEditDTO";
import { IAssetAssignmentDTO } from "../models/asset/assetAssignmentDTO";
import { IAssetRepairListingResponse } from "../models/asset/response/AssetRepairListingResponse";
import { AssetHistoryModel } from "../models/asset/assetHistoryDTO";
import { AssetRepairHistoryModel } from "../models/asset/assetRepairHistoryDTO";
import GridOption, { GridOptionModel } from "../models/shared/gridOption";
import { AssetReportDetailModel } from "../models/asset/assetReportDetailDTO";
import { SummaryReportModel } from "../models/asset/summaryReportDTO";
import { IAssetReportDTO } from "../models/asset/assetReportDTO";
import { IAssetCurrentReportResponse } from "../models/asset/response/assetCurrentReportResponse";
import { AssetCurrentReportModel } from "../models/asset/assetCurrentReportDTO";
import { IAssetCullOutReportRequestDTO } from "../models/asset/assetCullOtReportRequestDTO";
let AssetModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62;
    let AssetModule = class AssetModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.assetTypes = [];
            this.assetType = new AssetTypeModel();
            this.assetAssigns = [];
            this.assetMaster = [];
            this.assetControlType = [];
            this.assetDataType = [];
            this.defaultStatusId = null;
            this.getAssetControlType = [];
            this.getAssetStatusType = [];
            this.getAssetProperties = [];
            this.getAssetPropertiesValues = [];
            this.assetTypeProperty = [];
            this.assetControlTypeValue = [];
            this.assetLocations = [];
            // Asset Manager
            this.assetsManager = [];
            this.assets = [];
            this.assetsType = [];
            this.assetStatus = [];
            //Asset Current Report
            this.assetCurrentReport = [];
            this.assetsView = null;
            this.assetProperties = [];
            this.assetDetail = null;
            this.totalAssets = 0;
            //Asset History
            this.assetHistory = [];
            this.assetRepair = [];
            this.assetRepairs = [];
            //AssetAssignment
            this.employeeListing = [];
            this.assetAssignment = null;
            this.workPlace = [];
            this.apiNode = "Asset";
            // Asset Assignment
            this.getAssetData = [];
            this.getEmployeeData = [];
            // Asset Report
            this.assetReportDetails = [];
            this.assetSummaryReportDetails = [];
            this.assetScrappedDisposedReportDetails = [];
            this.assetCategories = [];
            this.yearList = [];
            this.teamList = [];
            this.cullOutReportAssetTypes = [];
            this.cullOutAssets = [];
            this.depreciatedAssets = [];
            //vendors
            this.vendors = [];
            this.assetCategory = [];
            this.ExportDataAssets = null;
            this.ExportDataAssetCurrent = null;
            this.assesmentYears = [];
            this.totalAssesmentYearCount = 0;
            this.pdfData = null;
            this.assessmentReportYear = "";
            //Back Propagtion
            this.searchParams = null;
        }
        SetAssetDetail() {
            this.assetDetail.statusId = "";
        }
        async GetAssetTypes() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetTypes(data.assetMaster);
            }
            return [];
        }
        SetAssetTypes(assetMaster) {
            this.assetControlType = plainToClass(GuidItemModel, assetMaster.assetControlType);
            this.assetDataType = plainToClass(GuidItemModel, assetMaster.assetDataType);
            this.assetTypes = plainToClass(AssetTypeModel, assetMaster.assetTypes);
            this.assetControlTypeValue = plainToClass(AssetControlTypeModel, assetMaster.assetControlTypeValue);
            this.assetCategory = assetMaster.assetCategory;
        }
        async AddAssetType(newAssetTypeName) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, newAssetTypeName);
            if (data) {
                this.SetAddAssetType(data.assetType);
                return data;
            }
        }
        SetAddAssetType(assetType) {
            this.assetTypes.push(assetType);
        }
        async UpdateAssetType(updateAssetTypeName) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.put(url, updateAssetTypeName);
            if (data) {
                this.SetUpdateAssetType(data.assetType);
                return data;
            }
        }
        SetUpdateAssetType(assetType) {
            var that = this;
            var target = that.assetTypes.findIndex((x) => x.id == assetType.id);
            if (target !== -1) {
                that.assetTypes[target] = plainToClass(AssetTypeModel, assetType);
            }
            else {
                that.assetTypes.push(plainToClass(AssetTypeModel, assetType));
            }
            that.assetTypes = [...that.assetTypes];
        }
        async GetAssetTypeProperties(assetTypeId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetTypeId + `/properties`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetTypeProperties(data.assetTypeProperties);
            }
            return [];
        }
        SetAssetTypeProperties(assetTypeProperty) {
            this.assetTypeProperty = plainToClass(AssetTypePropertyModel, assetTypeProperty);
        }
        async SetConfigurationOrder(assetTypePropertyId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetTypePropertyId + `/set-configOrder`;
            let { data } = await service.get(url);
            if (data) {
                this.SetSetConfigurationOrder(data.assetTypeProperty);
            }
            return data;
        }
        SetSetConfigurationOrder(assetTypeProperty) {
            var that = this;
            var target = that.assetTypeProperty.findIndex((x) => x.id == assetTypeProperty.id);
            that.assetTypeProperty[target].configurationOrder = assetTypeProperty.configurationOrder;
        }
        async ReSetConfigurationOrder(assetTypePropertyId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetTypePropertyId + `/reset-configOrder`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetTypeProperties(data.assetTypeProperties);
            }
            return [];
        }
        async ClearConfiguration(assetTypePropertyId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetTypePropertyId + `/clear-configOrder`;
            let { data } = await service.get(url);
            if (data) {
                this.ClearSetConfigurationOrder();
            }
            return data;
        }
        ClearSetConfigurationOrder() {
            for (var i = 0; i < this.assetTypeProperty.length; i++) {
                this.assetTypeProperty[i].configurationOrder = null;
            }
        }
        async AddAssetTypeProperty(AssetTypePropertyItem) {
            var url = `${getTenantId()}/${this.apiNode}/` + AssetTypePropertyItem.assetTypeId + `/properties`;
            let { data } = await service.post(url, AssetTypePropertyItem);
            if (data) {
                this.SetAddAssetTypeProperty(data.assetTypeProperty);
                return data;
            }
        }
        SetAddAssetTypeProperty(assetTypeProperty) {
            this.assetTypeProperty.push(plainToClass(AssetTypePropertyModel, assetTypeProperty));
        }
        async UpdateAssetTypeProperty(assetTypeProperty) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetTypeProperty.assetTypeId + `/properties`;
            let { data } = await service.put(url, assetTypeProperty);
            if (data) {
                this.SetUpdateAssetTypeProperty(data.assetTypeProperty);
                return data;
            }
        }
        SetUpdateAssetTypeProperty(assetTypeProperty) {
            var that = this;
            var target = that.assetTypeProperty.findIndex((x) => x.id == assetTypeProperty.id);
            if (target !== -1) {
                that.assetTypeProperty[target] = plainToClass(AssetTypePropertyModel, assetTypeProperty);
            }
            else {
                that.assetTypeProperty.push(plainToClass(AssetTypePropertyModel, assetTypeProperty));
            }
            that.assetTypeProperty = [...that.assetTypeProperty];
        }
        async GetAssetTypePropertiesByAssetTypeId(assetTypeId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetTypeId + `/getAddAsset`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAddAssetTypeProperties(data.assetProperties);
                this.SetDefaultStatusId(data.defaultStatusId);
                this.SetAssetControlType(data.assetControlType);
            }
            return [];
        }
        SetAddAssetTypeProperties(assetProperty) {
            this.getAssetProperties = plainToClass(AssetPropertyModel, assetProperty);
        }
        SetAddAssetTypePropertiesValues(assetPropertyValues) {
            this.getAssetPropertiesValues = plainToClass(AssetPropertyModel, assetPropertyValues);
        }
        async clearGetAssetProperties() {
            this.getAssetProperties = [];
        }
        async clearGetAssetPropertiesValues() {
            this.getAssetPropertiesValues = [];
        }
        SetAssetControlType(assetControlType) {
            this.getAssetControlType = plainToClass(AssetControlTypeModel, assetControlType);
        }
        SetDefaultStatusId(defaultStatusId) {
            this.defaultStatusId = defaultStatusId;
        }
        async SaveAsset(asset) {
            var url = `${getTenantId()}/${this.apiNode}/` + `AddAsset`;
            let { data } = await service.post(url, asset);
            if (data) {
            }
            return [];
        }
        // Asset Manager Modules
        async GetAssetDetails(assetId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetId + `/assetEdit`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetDetails(plainToClass(AssetEditModel, data.asset));
                this.SetAddAssetTypePropertiesValues(plainToClass(AssetPropertyModel, data.asset.assetProperties));
                this.SetAddAssetTypeProperties(plainToClass(AssetPropertyModel, data.assetTypeProperties));
                this.SetAssetControlType(data.assetControlType);
                this.SetAssetStatusType(data.assetStatusType);
                this.SetAssetVendors(data.vendors);
                this.SetAssetType(data.assetTypes);
                this.SetAssetLocation(data.assetLocation);
                this.setAssetCategory(data.categories);
                return data;
            }
        }
        setAssetCategory(categories) {
            this.assetCategory = plainToClass(GuidItemModel, categories);
        }
        SetAssetVendors(vendors) {
            this.vendors = plainToClass(GuidItemModel, vendors);
        }
        SetAssetType(assetType) {
            this.assetTypes = plainToClass(AssetTypeModel, assetType);
        }
        SetAssetLocation(assetLocation) {
            this.assetLocations = plainToClass(GuidItemModel, assetLocation);
        }
        async GetAssetDefaults() {
            var url = `${getTenantId()}/${this.apiNode}/defaults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssets(data);
                return data;
            }
        }
        SetAssetDetails(assetDetail) {
            this.assetDetail = assetDetail;
            var newnumber = new Number(assetDetail.price).toFixed(2);
            this.assetDetail.price = newnumber;
        }
        SetAssetStatusType(assetStatusType) {
            this.getAssetStatusType = plainToClass(AssetControlTypeModel, assetStatusType);
        }
        async UpdateAsset(updateAsset) {
            var url = `${getTenantId()}/${this.apiNode}` + `/updateAsset`;
            let { data } = await service.put(url, updateAsset);
            if (data) {
                this.SetAssetDetail();
                this.SetAssetDetailStatus();
                this.SetAssetStatusType(data.assetStatusType);
                return data;
            }
        }
        SetAssetDetailStatus() {
            this.assetDetail.repairStatus = false;
        }
        async GetAssets(searchData) {
            var url = `${getTenantId()}/${this.apiNode}/assets`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetAssets(data);
            }
            return data;
        }
        SetAssets(data) {
            this.assets = plainToClass(AssetManagerModel, data.assetsManager.assets);
            this.assetStatus = plainToClass(GuidItemModel, data.assetsManager.assetStatus);
            this.assetsType = plainToClass(AssetTypeModel, data.assetsManager.assetsType);
            this.totalAssets = data.totalCount;
            this.vendors = plainToClass(GuidItemModel, data.assetsManager.vendors);
            this.assetCategory = plainToClass(GuidItemModel, data.assetsManager.categories);
            this.assetLocations = plainToClass(GuidItemModel, data.assetsManager.assetLocation);
        }
        async GetAssetCurrentReport() {
            var url = `${getTenantId()}/${this.apiNode}/assets-current-report`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetCurrentReport(data);
            }
            return data;
        }
        SetAssetCurrentReport(data) {
            this.assetCurrentReport = plainToClass(AssetCurrentReportModel, data.assetCurrentReport);
        }
        async DeleteAssetById(assetId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetId + "/deleteAsset";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        // Getting Repaired Assets
        async GetRepairedAssets() {
            var url = `${getTenantId()}/${this.apiNode}/repairedAssets`;
            let { data } = await service.get(url);
            if (data) {
                this.SetRepairedAssets(data);
            }
            return data;
        }
        SetRepairedAssets(data) {
            this.assets = plainToClass(AssetManagerModel, data.assets);
            this.totalAssets = data.totalCount;
        }
        // Asset Lookup Search
        async GetAssetsByLookup(searchLookupAsset) {
            var url = `${getTenantId()}/${this.apiNode}/` + searchLookupAsset + "/assetLookup";
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetsByLookup(data.assets);
            }
            return [];
        }
        SetAssetsByLookup(assetProperty) {
            this.getAssetData = plainToClass(AssetLookupSearchModel, assetProperty);
        }
        // Employee Lookup Search
        async GetEmployeesByLookup(searchLookupEmployee) {
            var url = `${getTenantId()}/${this.apiNode}/` + searchLookupEmployee + "/employeeLookup";
            let { data } = await service.get(url);
            if (data) {
                this.SetEmployeesByLookup(data.employees);
            }
            return [];
        }
        SetEmployeesByLookup(employees) {
            this.getEmployeeData = plainToClass(EmployeesGridViewModel, employees);
        }
        //Asset Assignment
        async AddAssetAssignment(newAssetAssignment) {
            var url = `${getTenantId()}/${this.apiNode}/` + `AssetAssign`;
            let { data } = await service.post(url, newAssetAssignment);
            if (data) {
                return data;
            }
        }
        async GetAssetsView(assetId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetId + `/assetsManager`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetsView(data.assetManagerDetailView);
            }
            return data;
        }
        SetAssetsView(assertView) {
            this.assetsView = plainToClass(AssetDetailViewModel, assertView.assetsView);
            this.assetProperties = plainToClass(AssetPropertiesDetailViewModel, assertView.assetProperties);
        }
        //Asset Assignment
        async GetAllActiveEmployees(employeeId) {
            var url = `${getTenantId()}/${this.apiNode}/` + employeeId + `/assetAssignment`;
            let { data } = await service.get(url);
            if (data) {
                this.EmployeesList(data.assetAssignmentGridView);
                return data;
            }
        }
        EmployeesList(assetAssignmentGridView) {
            this.employeeListing = plainToClass(EmployeesGridViewModel, assetAssignmentGridView.employeesListing);
            this.assetAssignment = plainToClass(EmployeeAssetsGridViewModel, assetAssignmentGridView.firstEmployeeAssets);
        }
        async GetEmployeeAssets(empId) {
            var url = `${getTenantId()}/${this.apiNode}/` + empId + `/employeeAssets`;
            let { data } = await service.get(url);
            if (data) {
                this.SetEmployeeAssets(data.employeeAssets);
                return data;
            }
        }
        SetEmployeeAssets(employeeAssets) {
            this.assetAssignment = plainToClass(EmployeeAssetsGridViewModel, employeeAssets);
        }
        //WorkPlace Edit
        async UpdateWorkPlace(dto) {
            var url = `${getTenantId()}/${this.apiNode}` + `/updateWorkPlace`;
            let { data } = await service.put(url, dto);
            if (data) {
                return data;
            }
        }
        async RemoveAssetAssignment(assetId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetId + `/removeAsset`;
            let { data } = await service.put(url);
            if (data) {
                return data;
            }
        }
        async GenerateAssetIssueLetter({ empId, assetIds = [] }) {
            var url = `${getTenantId()}/${this.apiNode}/` + empId + `/issueLetter`;
            if (assetIds.length > 0) {
                url += '?' + assetIds.map(id => `assetIds=${encodeURIComponent(id)}`).join('&');
            }
            const response = await service.get(url, { responseType: "blob" });
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'AssetIssueLetter.pdf';
            if (contentDisposition) {
                const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match)
                    fileName = match[1].replace(/['"]/g, '');
            }
            return { blob: response.data, fileName };
        }
        async GenerateAssetReturnLetter({ empId, assets = [] }) {
            var url = `${getTenantId()}/${this.apiNode}/` + empId + `/returnLetter`;
            const response = await service.post(url, { assets }, { responseType: "blob" });
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'AssetReturnLetter.pdf';
            if (contentDisposition) {
                const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match)
                    fileName = match[1].replace(/['"]/g, '');
            }
            return { blob: response.data, fileName };
        }
        // Asset History
        async GetAssetHistory(assetId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetId + `/assetHistories`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetHistory(plainToClass(AssetHistoryModel, data.assetHistory));
                this.SetAssetRepairHistory(data.assetRepair);
            }
            return data;
        }
        SetAssetHistory(assetHistory) {
            this.assetHistory = assetHistory;
        }
        SetAssetRepairHistory(assetRepair) {
            this.assetRepair = plainToClass(AssetRepairHistoryModel, assetRepair);
        }
        async DeleteAssetTypeById(assetTypeId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetTypeId + `/deleteAssetType`;
            let { data } = await service.delete(url);
            return data;
        }
        async DeleteAssetTypePropertiesById(assetTypePropertyId) {
            var url = `${getTenantId()}/${this.apiNode}/` + assetTypePropertyId + `/deleteAssetTypeProperties`;
            let { data } = await service.delete(url);
            return data;
        }
        async GetAssetPurchaseReport(assetReport) {
            var url = `${getTenantId()}/${this.apiNode}/asset-purchase-report`;
            let { data } = await service.post(url, assetReport);
            if (data) {
                this.SetAssetPurchaseReport(plainToClass(AssetReportDetailModel, data.assetReportDetails));
                return data;
            }
        }
        SetAssetPurchaseReport(assetReportDetails) {
            this.assetReportDetails = assetReportDetails;
        }
        async GetAssetScrappedDisposedReport(assetReport) {
            var url = `${getTenantId()}/${this.apiNode}/assets-scrapped-disposed-report`;
            let { data } = await service.post(url, assetReport);
            if (data) {
                this.SetAssetScrappedDisposedReport(data.assetScrappedDisposedReportDetails);
                return data;
            }
        }
        SetAssetScrappedDisposedReport(details) {
            this.assetScrappedDisposedReportDetails = details;
        }
        async GetAssetsSummaryReport(snapShotDate) {
            var url = `${getTenantId()}/${this.apiNode}/assets-summary-report?snapShotDate=${snapShotDate}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetsSummaryReport(plainToClass(SummaryReportModel, data.assetSummaryReportDetails));
                return data;
            }
        }
        SetAssetsSummaryReport(assetSummaryReportDetails) {
            this.assetSummaryReportDetails = assetSummaryReportDetails;
        }
        ClearAssetData() {
            this.getAssetData = [];
        }
        ClearEmployeeData() {
            this.getEmployeeData = [];
        }
        // Excel Export
        async GetAssetPurchaseReportAsExcel(assetReport) {
            var url = `${getTenantId()}/${this.apiNode}/Excel/assetPurchasereport`;
            let { data } = await service.post(url, assetReport, { responseType: "blob" });
            return data;
        }
        async GetAssetsSummaryReportAsExcel(snapShotDate) {
            var url = `${getTenantId()}/${this.apiNode}/Excel/assetsSummaryreport?snapShotDate=${snapShotDate}`;
            let { data } = await service.post(url, snapShotDate, { responseType: "blob" });
            return data;
        }
        async GetAssetScrappedDisposedReportAsExcel(assetReport) {
            var url = `${getTenantId()}/${this.apiNode}/Excel/assetsScrappedDisposedReport`;
            let { data } = await service.post(url, assetReport, { responseType: "blob" });
            return data;
        }
        async AssetCullOutReport(cullOutRequest) {
            var url = `${getTenantId()}/${this.apiNode}/assets-cull-out-report`;
            let { data } = await service.post(url, cullOutRequest);
            if (data) {
                this.SetCullOutAssetsReport(data.cullOutAssets);
            }
            return data;
        }
        async AssetCullOutReportAsExcel(cullOutRequest) {
            var url = `${getTenantId()}/${this.apiNode}/assets-cull-out-report/Excel`;
            let { data } = await service.post(url, cullOutRequest, { responseType: "blob" });
            return data;
        }
        SetCullOutAssetsReport(cullOutAssets) {
            this.cullOutAssets = cullOutAssets;
        }
        async ClearYearlyAssetsReport() {
            this.cullOutAssets = [];
        }
        async AssetCullOutReportDefaults() {
            var url = `${getTenantId()}/${this.apiNode}/assets-cull-out-report-defaults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetCategoriesListsForAssetCullOutReport(data.assetCategories);
                this.SetYearListsForAssetCullOutReport(data.yearList);
                this.SetTeamListsForAssetCullOutReport(data.teamList);
            }
            return data;
        }
        SetCategoriesListsForAssetCullOutReport(assetCategories) {
            this.assetCategories = assetCategories;
        }
        SetYearListsForAssetCullOutReport(yearList) {
            this.yearList = yearList;
        }
        SetTeamListsForAssetCullOutReport(teamList) {
            this.teamList = teamList;
        }
        // Depreciation Report
        async GetAssetAssessmentYears(searchData) {
            var url = `${getTenantId()}/${this.apiNode}/depreciation/assessmentYears`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetAssetAssesmentYear(data);
                return data;
            }
        }
        SetAssetAssesmentYear(data) {
            this.assesmentYears = data.assetAssessmentYear;
            this.totalAssesmentYearCount = data.totalCount;
        }
        async RunAssetsDepreciation(assetAssessmentYearId) {
            var url = `${getTenantId()}/${this.apiNode}/depreciation/run/${assetAssessmentYearId}`;
            let { data } = await service.get(url);
            if (data) {
                return data;
            }
        }
        async AssetDepreciationReportAsExcel(assessmentYearId) {
            var url = `${getTenantId()}/${this.apiNode}/assets-depreciation-report/excel/${assessmentYearId}`;
            let { data } = await service.get(url, { responseType: "blob" });
            if (data) {
                this.ExcelblobData(data);
                this.setAssesmentYears(assessmentYearId);
            }
            return data;
        }
        ExcelblobData(blob) {
            this.pdfData = blob;
        }
        setAssesmentYears(assessmentYearId) {
            this.assessmentReportYear = this.assesmentYears.find((x) => x.id == assessmentYearId)?.formatedYearRange;
        }
        async GetAssetTypeByAssetCategoryId(assetCatergoryId) {
            var url = `${getTenantId()}/${this.apiNode}/assetTypes/` + assetCatergoryId;
            let { data } = await service.get(url);
            if (data) {
                this.SetAssetTypeByAssetCategoryId(data.cullOutReportAssetTypes);
            }
            return data;
        }
        SetAssetTypeByAssetCategoryId(cullOutReportAssetTypes) {
            this.cullOutReportAssetTypes = cullOutReportAssetTypes;
        }
        async clearGetAssetTypes() {
            this.cullOutReportAssetTypes = [];
        }
        async GetAssetCurrentReportAsExcel() {
            var url = `${getTenantId()}/${this.apiNode}/assets-current-report/excel`;
            let { data } = await service.get(url, { responseType: "blob" });
            return data;
        }
        async GetAssetsExcel(searchData) {
            var url = `${getTenantId()}/${this.apiNode}/assetManager-excelExport`;
            let { data } = await service.post(url, searchData, { responseType: "blob" });
            if (data) {
                this.ExportAssetExcel(data);
            }
            return data;
        }
        ExportAssetExcel(data) {
            this.ExportDataAssets = data;
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
        AssignSearchParams(param) {
            this.searchParams = _.cloneDeep(param);
        }
    };
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetDetail", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], AssetModule.prototype, "GetAssetTypes", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof IAssetTypeMaster !== "undefined" && IAssetTypeMaster) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetTypes", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof AssetTypeModel !== "undefined" && AssetTypeModel) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], AssetModule.prototype, "AddAssetType", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof IAssetTypeDTO !== "undefined" && IAssetTypeDTO) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAddAssetType", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof AssetTypeModel !== "undefined" && AssetTypeModel) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], AssetModule.prototype, "UpdateAssetType", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof IAssetTypeDTO !== "undefined" && IAssetTypeDTO) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetUpdateAssetType", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], AssetModule.prototype, "GetAssetTypeProperties", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetTypeProperties", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], AssetModule.prototype, "SetConfigurationOrder", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof IAssetTypePropertyDTO !== "undefined" && IAssetTypePropertyDTO) === "function" ? _l : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetSetConfigurationOrder", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], AssetModule.prototype, "ReSetConfigurationOrder", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], AssetModule.prototype, "ClearConfiguration", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "ClearSetConfigurationOrder", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof AssetTypePropertyModel !== "undefined" && AssetTypePropertyModel) === "function" ? _p : Object]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], AssetModule.prototype, "AddAssetTypeProperty", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof IAssetTypePropertyDTO !== "undefined" && IAssetTypePropertyDTO) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAddAssetTypeProperty", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_s = typeof IAssetTypePropertyDTO !== "undefined" && IAssetTypePropertyDTO) === "function" ? _s : Object]),
        __metadata("design:returntype", typeof (_t = typeof Promise !== "undefined" && Promise) === "function" ? _t : Object)
    ], AssetModule.prototype, "UpdateAssetTypeProperty", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_u = typeof IAssetTypePropertyDTO !== "undefined" && IAssetTypePropertyDTO) === "function" ? _u : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetUpdateAssetTypeProperty", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_v = typeof Guid !== "undefined" && Guid) === "function" ? _v : Object]),
        __metadata("design:returntype", typeof (_w = typeof Promise !== "undefined" && Promise) === "function" ? _w : Object)
    ], AssetModule.prototype, "GetAssetTypePropertiesByAssetTypeId", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAddAssetTypeProperties", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAddAssetTypePropertiesValues", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AssetModule.prototype, "clearGetAssetProperties", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AssetModule.prototype, "clearGetAssetPropertiesValues", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetControlType", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_x = typeof Guid !== "undefined" && Guid) === "function" ? _x : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetDefaultStatusId", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_y = typeof AssetModel !== "undefined" && AssetModel) === "function" ? _y : Object]),
        __metadata("design:returntype", typeof (_z = typeof Promise !== "undefined" && Promise) === "function" ? _z : Object)
    ], AssetModule.prototype, "SaveAsset", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_0 = typeof Guid !== "undefined" && Guid) === "function" ? _0 : Object]),
        __metadata("design:returntype", typeof (_1 = typeof Promise !== "undefined" && Promise) === "function" ? _1 : Object)
    ], AssetModule.prototype, "GetAssetDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "setAssetCategory", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetVendors", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetType", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetLocation", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_2 = typeof Promise !== "undefined" && Promise) === "function" ? _2 : Object)
    ], AssetModule.prototype, "GetAssetDefaults", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_3 = typeof IAssetEditDTO !== "undefined" && IAssetEditDTO) === "function" ? _3 : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetStatusType", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_4 = typeof AssetEditModel !== "undefined" && AssetEditModel) === "function" ? _4 : Object]),
        __metadata("design:returntype", typeof (_5 = typeof Promise !== "undefined" && Promise) === "function" ? _5 : Object)
    ], AssetModule.prototype, "UpdateAsset", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetDetailStatus", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_6 = typeof GridOption !== "undefined" && GridOption) === "function" ? _6 : Object]),
        __metadata("design:returntype", typeof (_7 = typeof Promise !== "undefined" && Promise) === "function" ? _7 : Object)
    ], AssetModule.prototype, "GetAssets", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_8 = typeof IAssetManagerResponse !== "undefined" && IAssetManagerResponse) === "function" ? _8 : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssets", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_9 = typeof Promise !== "undefined" && Promise) === "function" ? _9 : Object)
    ], AssetModule.prototype, "GetAssetCurrentReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_10 = typeof IAssetCurrentReportResponse !== "undefined" && IAssetCurrentReportResponse) === "function" ? _10 : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetCurrentReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_11 = typeof Guid !== "undefined" && Guid) === "function" ? _11 : Object]),
        __metadata("design:returntype", typeof (_12 = typeof Promise !== "undefined" && Promise) === "function" ? _12 : Object)
    ], AssetModule.prototype, "DeleteAssetById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_13 = typeof Promise !== "undefined" && Promise) === "function" ? _13 : Object)
    ], AssetModule.prototype, "GetRepairedAssets", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_14 = typeof IAssetRepairListingResponse !== "undefined" && IAssetRepairListingResponse) === "function" ? _14 : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetRepairedAssets", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_15 = typeof Promise !== "undefined" && Promise) === "function" ? _15 : Object)
    ], AssetModule.prototype, "GetAssetsByLookup", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetsByLookup", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_16 = typeof Promise !== "undefined" && Promise) === "function" ? _16 : Object)
    ], AssetModule.prototype, "GetEmployeesByLookup", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetEmployeesByLookup", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_17 = typeof IAssetAssignmentDTO !== "undefined" && IAssetAssignmentDTO) === "function" ? _17 : Object]),
        __metadata("design:returntype", typeof (_18 = typeof Promise !== "undefined" && Promise) === "function" ? _18 : Object)
    ], AssetModule.prototype, "AddAssetAssignment", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_19 = typeof Promise !== "undefined" && Promise) === "function" ? _19 : Object)
    ], AssetModule.prototype, "GetAssetsView", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_20 = typeof IAssetManagerDetailView !== "undefined" && IAssetManagerDetailView) === "function" ? _20 : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetsView", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_21 = typeof Guid !== "undefined" && Guid) === "function" ? _21 : Object]),
        __metadata("design:returntype", typeof (_22 = typeof Promise !== "undefined" && Promise) === "function" ? _22 : Object)
    ], AssetModule.prototype, "GetAllActiveEmployees", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_23 = typeof IAssetAssignment !== "undefined" && IAssetAssignment) === "function" ? _23 : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "EmployeesList", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_24 = typeof Guid !== "undefined" && Guid) === "function" ? _24 : Object]),
        __metadata("design:returntype", typeof (_25 = typeof Promise !== "undefined" && Promise) === "function" ? _25 : Object)
    ], AssetModule.prototype, "GetEmployeeAssets", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_26 = typeof EmployeeAssetsGridViewModel !== "undefined" && EmployeeAssetsGridViewModel) === "function" ? _26 : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetEmployeeAssets", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_27 = typeof AssetAssignmentEditModel !== "undefined" && AssetAssignmentEditModel) === "function" ? _27 : Object]),
        __metadata("design:returntype", typeof (_28 = typeof Promise !== "undefined" && Promise) === "function" ? _28 : Object)
    ], AssetModule.prototype, "UpdateWorkPlace", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_29 = typeof Guid !== "undefined" && Guid) === "function" ? _29 : Object]),
        __metadata("design:returntype", typeof (_30 = typeof Promise !== "undefined" && Promise) === "function" ? _30 : Object)
    ], AssetModule.prototype, "RemoveAssetAssignment", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_31 = typeof Promise !== "undefined" && Promise) === "function" ? _31 : Object)
    ], AssetModule.prototype, "GenerateAssetIssueLetter", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_32 = typeof Promise !== "undefined" && Promise) === "function" ? _32 : Object)
    ], AssetModule.prototype, "GenerateAssetReturnLetter", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_33 = typeof Promise !== "undefined" && Promise) === "function" ? _33 : Object)
    ], AssetModule.prototype, "GetAssetHistory", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetHistory", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetRepairHistory", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_34 = typeof Promise !== "undefined" && Promise) === "function" ? _34 : Object)
    ], AssetModule.prototype, "DeleteAssetTypeById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_35 = typeof Promise !== "undefined" && Promise) === "function" ? _35 : Object)
    ], AssetModule.prototype, "DeleteAssetTypePropertiesById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_36 = typeof IAssetReportDTO !== "undefined" && IAssetReportDTO) === "function" ? _36 : Object]),
        __metadata("design:returntype", typeof (_37 = typeof Promise !== "undefined" && Promise) === "function" ? _37 : Object)
    ], AssetModule.prototype, "GetAssetPurchaseReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetPurchaseReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_38 = typeof IAssetReportDTO !== "undefined" && IAssetReportDTO) === "function" ? _38 : Object]),
        __metadata("design:returntype", typeof (_39 = typeof Promise !== "undefined" && Promise) === "function" ? _39 : Object)
    ], AssetModule.prototype, "GetAssetScrappedDisposedReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetScrappedDisposedReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_40 = typeof String !== "undefined" && String) === "function" ? _40 : Object]),
        __metadata("design:returntype", typeof (_41 = typeof Promise !== "undefined" && Promise) === "function" ? _41 : Object)
    ], AssetModule.prototype, "GetAssetsSummaryReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetsSummaryReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "ClearAssetData", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "ClearEmployeeData", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_42 = typeof IAssetReportDTO !== "undefined" && IAssetReportDTO) === "function" ? _42 : Object]),
        __metadata("design:returntype", typeof (_43 = typeof Promise !== "undefined" && Promise) === "function" ? _43 : Object)
    ], AssetModule.prototype, "GetAssetPurchaseReportAsExcel", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_44 = typeof String !== "undefined" && String) === "function" ? _44 : Object]),
        __metadata("design:returntype", typeof (_45 = typeof Promise !== "undefined" && Promise) === "function" ? _45 : Object)
    ], AssetModule.prototype, "GetAssetsSummaryReportAsExcel", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_46 = typeof IAssetReportDTO !== "undefined" && IAssetReportDTO) === "function" ? _46 : Object]),
        __metadata("design:returntype", typeof (_47 = typeof Promise !== "undefined" && Promise) === "function" ? _47 : Object)
    ], AssetModule.prototype, "GetAssetScrappedDisposedReportAsExcel", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_48 = typeof IAssetCullOutReportRequestDTO !== "undefined" && IAssetCullOutReportRequestDTO) === "function" ? _48 : Object]),
        __metadata("design:returntype", typeof (_49 = typeof Promise !== "undefined" && Promise) === "function" ? _49 : Object)
    ], AssetModule.prototype, "AssetCullOutReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_50 = typeof IAssetCullOutReportRequestDTO !== "undefined" && IAssetCullOutReportRequestDTO) === "function" ? _50 : Object]),
        __metadata("design:returntype", typeof (_51 = typeof Promise !== "undefined" && Promise) === "function" ? _51 : Object)
    ], AssetModule.prototype, "AssetCullOutReportAsExcel", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetCullOutAssetsReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AssetModule.prototype, "ClearYearlyAssetsReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_52 = typeof Promise !== "undefined" && Promise) === "function" ? _52 : Object)
    ], AssetModule.prototype, "AssetCullOutReportDefaults", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetCategoriesListsForAssetCullOutReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetYearListsForAssetCullOutReport", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetTeamListsForAssetCullOutReport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_53 = typeof GridOption !== "undefined" && GridOption) === "function" ? _53 : Object]),
        __metadata("design:returntype", typeof (_54 = typeof Promise !== "undefined" && Promise) === "function" ? _54 : Object)
    ], AssetModule.prototype, "GetAssetAssessmentYears", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetAssesmentYear", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_55 = typeof Promise !== "undefined" && Promise) === "function" ? _55 : Object)
    ], AssetModule.prototype, "RunAssetsDepreciation", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_56 = typeof Promise !== "undefined" && Promise) === "function" ? _56 : Object)
    ], AssetModule.prototype, "AssetDepreciationReportAsExcel", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "ExcelblobData", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "setAssesmentYears", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_57 = typeof Guid !== "undefined" && Guid) === "function" ? _57 : Object]),
        __metadata("design:returntype", typeof (_58 = typeof Promise !== "undefined" && Promise) === "function" ? _58 : Object)
    ], AssetModule.prototype, "GetAssetTypeByAssetCategoryId", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "SetAssetTypeByAssetCategoryId", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AssetModule.prototype, "clearGetAssetTypes", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_59 = typeof Promise !== "undefined" && Promise) === "function" ? _59 : Object)
    ], AssetModule.prototype, "GetAssetCurrentReportAsExcel", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_60 = typeof GridOption !== "undefined" && GridOption) === "function" ? _60 : Object]),
        __metadata("design:returntype", typeof (_61 = typeof Promise !== "undefined" && Promise) === "function" ? _61 : Object)
    ], AssetModule.prototype, "GetAssetsExcel", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "ExportAssetExcel", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "ClearSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_62 = typeof GridOptionModel !== "undefined" && GridOptionModel) === "function" ? _62 : Object]),
        __metadata("design:returntype", void 0)
    ], AssetModule.prototype, "AssignSearchParams", null);
    AssetModule = __decorate([
        Module({ dynamic: true, store: store, name: "asset", namespaced: true })
    ], AssetModule);
    return AssetModule;
})();
export const AssetMasterModule = getModule(AssetModule);
